export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14405.4ea4806c.jpg";